import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import { withdrawRequest } from "store/actions/walletAction";
import { getWalletLog } from "store/actions/walletAction";

const WithdrawModal = ({ isOpen, toggle }) => {
  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.auth);
  const { amount } = useSelector((state) => state.wallet);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawLoader, setWithdrawLoader] = useState(false);

  const handleWithdraw = () => {
    if (withdrawAmount < 5 || withdrawAmount > amount) {
      toast.warning("Please enter a correct amount");
    } else {
      setWithdrawLoader(true);
      dispatch(
        withdrawRequest(withdrawAmount, uid, () => {
          setWithdrawAmount("");
          setWithdrawLoader(false);
          toggle();
          dispatch(getWalletLog(uid, "", () => {}));
        })
      );
    }
  };
  useEffect(() => {
    setWithdrawAmount("");
  }, [toggle]);
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <p className="custom-table-heading custom-heading">
          Enter the amount you wish to withdraw:
        </p>
        <Input
          type="number"
          value={withdrawAmount}
          onChange={(e) => {
            setWithdrawAmount(Number(e.target.value));
          }}
          placeholder={`Enter amount (min: $5)`}
          min={5}
          max={amount && 1000}
        />
        <small className="text-danger">
          Note: Withdrawal must be at least $5
        </small>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleWithdraw}
          disabled={amount < withdrawAmount}
        >
          {withdrawLoader ? <Spinner size="sm" /> : "Withdraw"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default WithdrawModal;
